import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('F_TRIG');
